var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.76 3.35C15.76 3.97408 15.2541 4.48 14.63 4.48C14.0059 4.48 13.5 3.97408 13.5 3.35C13.5 2.72592 14.0059 2.22 14.63 2.22C15.2541 2.22 15.76 2.72592 15.76 3.35Z",
    fill: "currentColor",
    className: "accent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 9C3.75 11.89 6.11 14.25 9 14.25C11.89 14.25 14.25 11.89 14.25 9C14.25 6.11 11.9 3.75 9 3.75C6.1 3.75 3.75 6.11 3.75 9ZM5.25 9C5.25 6.93 6.93 5.25 9 5.25C11.07 5.25 12.75 6.93 12.75 9C12.75 11.07 11.07 12.75 9 12.75C6.93 12.75 5.25 11.07 5.25 9Z",
    fill: "currentColor",
    className: "accent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 18H2.7C1.21 18 0 16.79 0 15.3V2.7C0 1.21 1.21 0 2.7 0H15.3C16.79 0 18 1.21 18 2.7V15.3C18 16.79 16.79 18 15.3 18ZM2.7 1.5C2.04 1.5 1.5 2.04 1.5 2.7V15.3C1.5 15.96 2.04 16.5 2.7 16.5H15.3C15.96 16.5 16.5 15.96 16.5 15.3V2.7C16.5 2.04 15.96 1.5 15.3 1.5H2.7Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.ef61c3d26e1366fc3e2ce66ed4f2b89e.svg";
export { ForwardRef as ReactComponent };